import React__default from 'react';
import { actions } from 'react-table';

const pluginName = 'useRowEditing';
actions.resetRowEditing = 'resetRowEditing';
actions.toggleRowEditing = 'toggleRowEditing';
actions.toggleEditing = 'toggleEditing';

function reducer(state, action) {
  if (action.type === actions.init) {
    return {
      allowEditing: true,
      editingRowUniqueId: null,
      ...state
    };
  }

  if (action.type === actions.resetRowEditing || action.type === actions.resetPage || action.type === actions.gotoPage) {
    return { ...state,
      editingRowUniqueId: null
    };
  }

  if (action.type === actions.toggleRowEditing) {
    const {
      id
    } = action;
    return { ...state,
      editingRowUniqueId: id
    };
  }

  if (action.type === actions.toggleEditing) {
    return { ...state,
      allowEditing: !state.allowEditing
    };
  }

  return state;
}

function useInstance(instance) {
  const {
    dispatch
  } = instance;
  const resetRowEditing = React__default.useCallback(() => {
    dispatch({
      type: actions.resetRowEditing
    });
  }, [dispatch]);
  const toggleRowEditing = React__default.useCallback(id => {
    dispatch({
      type: actions.toggleRowEditing,
      id
    });
  }, [dispatch]);
  const toggleEditing = React__default.useCallback(() => {
    dispatch({
      type: actions.toggleEditing
    });
  }, [dispatch]);
  Object.assign(instance, {
    resetRowEditing,
    toggleRowEditing,
    toggleEditing
  });
}

const prepareRow = uniqueId => (row, {
  instance
}) => {
  const id = row.original[uniqueId];

  row.toggleRowEditing = () => {
    if (instance.state.editingRowUniqueId === id) {
      instance.resetRowEditing();
    } else {
      instance.toggleRowEditing(id);
    }
  };

  row.isEditing = row.original._createKey ? instance.state.editingRowUniqueId === row.original._createKey : instance.state.editingRowUniqueId === id;
  row.canEdit = instance.state.allowEditing && (row.isEditing || !instance.state.editingRowUniqueId);
};

const useRowEditing = uniqueId => {
  const plugin = hooks => {
    if (uniqueId) {
      hooks.stateReducers.push(reducer);
      hooks.useInstance.push(useInstance);
      hooks.prepareRow.push(prepareRow(uniqueId));
    }
  };

  plugin.pluginName = pluginName;
  return plugin;
};

export { useRowEditing };
//# sourceMappingURL=useRowEditing.js.map
